import { apiSlice } from "../../app/api/apiSlice";

export const organisationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrganisation: builder.mutation({
      query: (credentials) => ({
        url: "/organisation",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    saveMetadata: builder.mutation({
      query: (credentials) => ({
        url: "/organisation/save-metadata",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    selectPlan: builder.mutation({
      query: (credentials) => ({
        url: "/organisation/subscribe",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    getProviders: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/providers/${credentials.orgId}/1`,
        method: "POST",
        body: credentials,
      }),
    }),
    getProviderFilters: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/${credentials.orgId}/provider/filters`,
        method: "GET",
      }),
    }),
    getDepartments: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/departments/${credentials}/1`,
        method: "GET",
      }),
    }),
    fetchOrganisationCommunities: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/locations/${credentials}`,
        method: "GET",
      }),
    }),
    fetchVisitRules: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/visit-rules/${credentials.orgId}`,
        method: "POST",
        body: credentials,
      }),
    }),
    getPatients: builder.mutation({
      query: ({
        orgId,
        limit = 20,
        skip = 0,
        search,
        location,
        status,
        zones,
        isMember,
        sortBy,
        sortOrder,
        zips
      }) => ({
        url: `/organisation/patients/${orgId}/0`,
        method: "POST",
        body: { limit, skip, search, location, status, zones, isMember, sortBy, sortOrder ,zips},
      }),
    }),
    getPatientFilters: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/${credentials.orgId}/patient/filters`,
        method: "GET",
      }),
    }),
    setEHR: builder.mutation({
      query: (data) => ({
        url: `/organisation/set-ehr`,
        method: "POST",
        body: data,
      }),
    }),
    practiseId: builder.mutation({
      query: (credentials) => ({
        url: `/organisation/set-practice-id`,
        method: "POST",
        body: {
          practiceId: `${credentials.practiceId}`,
          ehrId: `${credentials.ehrId}`,
        },
      }),
    }),
    checkEHRUploadStatus: builder.mutation({
      query: () => ({
        url: `/organisation/check-ehr-status`,
        method: "GET",
      }),
    }),
    fetchCommunities: builder.mutation({
      query: ({ orgId, limit, skip, search, zones,zips, facilityTypes }) => ({
        url: `/organisation/communities/${orgId}?limit=${limit}&skip=${skip}&search=${search}&zones=${zones}&zips=${zips}&facilityTypes=${facilityTypes}`,
        method: "GET",
      }),
    }),
    fetchFacilities: builder.mutation({
      query: ({ orgId, limit, skip, search, zips, facilityTypes }) => ({
        url: `/organisation/facilities/${orgId}?limit=${limit}&skip=${skip}&search=${search}&zips=${zips}&facilityTypes=${facilityTypes}`,
        method: "GET",
      }),
    }),
    fetchUploadHistory: builder.mutation({
      query: (org_id) => ({
        url: `/organisation/upload-history/${org_id}`,
        method: "GET",
      }),
    }),
    fetchContacts: builder.mutation({
      query: () => ({
        url: `/organisation/contacts`,
        method: "GET",
      }),
    }),
    fetchOrganisationRoles: builder.mutation({
      query: ({ orgId }) => ({
        url: `/organisation/roles/${orgId}`,
        method: "GET",
      }),
    }),
    getLocationBounds: builder.mutation({
      query: (credentials) => ({
        url: "/organisation/location-bounds",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    fetchReferralSources: builder.mutation({
      query: ({ orgId, limit, skip, search, zones }) => {
        const params = new URLSearchParams();

        if (limit !== undefined) params.append("limit", limit);
        if (skip !== undefined) params.append("skip", skip);
        if (search) params.append("search", search);
        if (zones) params.append("zones", zones);

        return {
          url: `/organisation/referral-sources/${orgId}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
    getProvidersAvailability: builder.mutation({
      query: ({ organisationId, status }) => ({
        url: `/organisation/providers/availability/${organisationId}`,
        method: "POST",
        body: { status },
      }),
    }),
  }),
});
export const {
  useCreateOrganisationMutation,
  useSaveMetadataMutation,
  useSelectPlanMutation,
  useGetProvidersMutation,
  useGetDepartmentsMutation,
  useFetchOrganisationCommunitiesMutation,
  useFetchVisitRulesMutation,
  useGetPatientsMutation,
  useSetEHRMutation,
  usePractiseIdMutation,
  useCheckEHRUploadStatusMutation,
  useFetchCommunitiesMutation,
  useFetchUploadHistoryMutation,
  useFetchContactsMutation,
  useGetLocationBoundsMutation,
  useFetchReferralSourcesMutation,
  useGetProvidersAvailabilityMutation,
  useGetProviderFiltersMutation,
  useGetPatientFiltersMutation,
  useFetchOrganisationRolesMutation,
  useFetchFacilitiesMutation,
} = organisationApiSlice;
